import React from 'react'
import ImageComponent from './image'
const SectionTourComponent = props =>
    <div className="section--primary">
        <div className="section__grid" id="tour">
            <div className="section__img u-text-center">
                <ImageComponent image="tour" />
            </div>
            <div className="section__text">
                <h2>Tour</h2>
                <p className="section__subtitle"><strong>Informal evening tours and one-day excursion</strong></p>
                <p>Since 2015, the Arab and Norman buildings and infrastructures of Palermo, Cefalù and Monreale have been <a href="http://whc.unesco.org/en/list/1487" target="_blank" className="section__link">UNESCO World Heritage sites</a>.<br />
                The important Arab and Norman sites scattered throughout <strong>Palermo</strong> represent major attractions and they will be part of informal evening tours.</p>
                <div>The evening tours could include visits to:
                <ul className="section__list">
                    <li>Palermo Royal Palace and Palatine Chapel</li>
                    <li>Palermo Cathedral</li>
                    <li>Church of San Giovanni degli Eremiti</li>
                    <li>Church of Santa Maria dell’Ammiraglio</li>
                    <li>Church of San Cataldo</li>
                    <li>Church of Magione</li>
                </ul>
                </div>
                <p>
                    <strong>The Cathedral and town of Cefalù (and its beach!)</strong> have been chosen for the <strong>one-day excursion</strong>, which will take place on <strong>29<sup>th</sup> of June 2018</strong>.</p>
                <p>
                    On the registration form you will be asked if you are interested in the one-day excursion
                    </p>
            </div>

        </div>
    </div>

export default SectionTourComponent



// WEBPACK FOOTER //
// ./src/components/section-tour.js